import {makeActionCreator} from '../utility'

export const SUBMIT_INDIVIDUAL_APPLICATION = 'SUBMIT_INDIVIDUAL_APPLICATION'
export const submitIndividualApplication = makeActionCreator(SUBMIT_INDIVIDUAL_APPLICATION, 'data')

export const SUBMIT_INDIVIDUAL_APPLICATION_SUCCESSFUL = 'SUBMIT_INDIVIDUAL_APPLICATION_SUCCESSFUL'
export const submitIndividualApplicationSuccessful = makeActionCreator(SUBMIT_INDIVIDUAL_APPLICATION_SUCCESSFUL, 'data')


export const FETCH_INDIVIDUAL_APPLICATION = 'FETCH_INDIVIDUAL_APPLICATION'
export const fetchIndividualApplication = makeActionCreator(FETCH_INDIVIDUAL_APPLICATION, 'data')

export const FETCH_INDIVIDUAL_APPLICATION_RECEIVED = 'FETCH_INDIVIDUAL_APPLICATION_RECEIVED'
export const fetchIndividualApplicationReceived = makeActionCreator(FETCH_INDIVIDUAL_APPLICATION_RECEIVED, 'data')



export const UPDATE_INDIVIDUAL_APPLICATION = 'UPDATE_INDIVIDUAL_APPLICATION'
export const updateIndividualApplication = makeActionCreator(UPDATE_INDIVIDUAL_APPLICATION, 'data')

export const INDIVIDUAL_APPLICATION_UPDATED = 'INDIVIDUAL_APPLICATION_UPDATED'
export const individualApplicantUpdated = makeActionCreator(INDIVIDUAL_APPLICATION_UPDATED, 'data')


export const FETCH_INDIVIDUAL_APPLICATION_REPORT = 'FETCH_INDIVIDUAL_APPLICATION_REPORT'
export const fetchIndividualApplicationReport = makeActionCreator(FETCH_INDIVIDUAL_APPLICATION_REPORT, 'data')

export const FETCH_INDIVIDUAL_APPLICATION_REPORT_RECEIVED = 'FETCH_INDIVIDUAL_APPLICATION_REPORT_RECEIVED'
export const fetchIndividualApplicationReportReceived = makeActionCreator(FETCH_INDIVIDUAL_APPLICATION_REPORT_RECEIVED, 'data')


export const HAS_POSTED = 'HAS_POSTED'
export const hasPosted = makeActionCreator(HAS_POSTED, 'data')


export const DELETE_APPLICATION = 'DELETE_APPLICATION'
export const deleteApplication = makeActionCreator(DELETE_APPLICATION, 'data')

export const HAS_DELETED_APPLICATION = 'HAS_DELETED_APPLICATION'
export const hasDeletedApplication = makeActionCreator(HAS_DELETED_APPLICATION, 'data')


export const CLEAR_APPLICATIONS = 'CLEAR_APPLICATIONS'
export const clearApplications = makeActionCreator(CLEAR_APPLICATIONS, 'data')


export const VALIDATE_MEMBERSHIP_NUMBER = 'VALIDATE_MEMBERSHIP_NUMBER'
export const validateMembershipNumber = makeActionCreator(VALIDATE_MEMBERSHIP_NUMBER, 'data')


export const VALIDATED_MEMBERSHIP_NUMBER = 'VALIDATED_MEMBERSHIP_NUMBER'
export const validatedMembershipNumber = makeActionCreator(VALIDATED_MEMBERSHIP_NUMBER, 'data')


export const FETCH_CLASS_DETAILS = 'FETCH_CLASS_DETAILS'
export const fetchClassDetails = makeActionCreator(FETCH_CLASS_DETAILS, 'data')


export const CLASS_DETAILS_RECEIVED = 'CLASS_DETAILS_RECEIVED'
export const classDetailsReceived = makeActionCreator(CLASS_DETAILS_RECEIVED, 'data')



export const FETCH_CLASS_NOTES_DETAILS = 'FETCH_CLASS_NOTES_DETAILS'
export const fetchClassNotesDetails = makeActionCreator(FETCH_CLASS_NOTES_DETAILS, 'data')

export const CLASS_NOTES_DETAILS_RECEIVED = 'CLASS_NOTES_DETAILS_RECEIVED'
export const classNotesDetailsReceived = makeActionCreator(CLASS_NOTES_DETAILS_RECEIVED, 'data')


export const FETCH_COUNTRIES = 'FETCH_COUNTRIES'
export const fetchCountries = makeActionCreator(FETCH_COUNTRIES, 'data')


export const HAS_FETCHED_COUNTRIES = 'HAS_FETCHED_COUNTRIES'
export const hasFetchedCountries = makeActionCreator(HAS_FETCHED_COUNTRIES, 'data')